// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.serviceTopicDiv {
  display: flex;
  flex-direction: row;
  margin-bottom: 200px;
}

.serviceImg {
  height: 650px;
  width: 650px;
}

.interiorImg {
  height: 625px;
  width: 730px;
}

.flooringImg {
  height: 625px;
  width: 730px;
}

.pressureImg {
  height: 685px;
}

.serviceQuoteBtn {
  background-color: #F27400;
  color: white;
  border-style: none;
  font-weight: 700;
  height: 50px;
  width: 150px;
}

.textsDiv {
  width: 230px;
  margin: 80px;
}
.textsDiv .servicePara {
  font-weight: 600;
  line-height: 20px;
}

.rightFacing {
  display: flex;
  flex-direction: row-reverse;
}

.pressure2 {
  margin-bottom: 100px;
}

@media (max-width: 425px) {
  .interiorImg {
    height: 425px;
    width: 630px;
  }

  .rightFacing {
    width: 232%;
  }

  .serviceImg {
    height: 530px;
    width: 550px;
  }

  .textsDiv {
    width: 250px;
  }
  .textsDiv h3 {
    font-size: 35px;
  }
  .textsDiv .servicePara {
    font-weight: 600;
    line-height: 33px;
    width: 233px;
    font-size: 24px;
  }

  .serviceQuoteBtn {
    font-size: 22px;
    height: 67px;
    width: 200px;
  }
}`, "",{"version":3,"sources":["webpack://./src/CSS/ServiceTopic.scss","webpack://./src/CSS/_variables.scss"],"names":[],"mappings":"AAUA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;AATJ;;AAcA;EAhBI,aAAA;EACA,YAAA;AAMJ;;AAaA;EAhBI,aAAA;EACA,YAAA;AAOJ;;AAYA;EApBI,aAAA;EACA,YAAA;AAYJ;;AAWA;EACI,aAAA;AARJ;;AAWA;EACI,yBCnCY;EDoCZ,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;AARJ;;AAWA;EACI,YAAA;EACA,YAAA;AARJ;AASI;EACI,gBAAA;EACA,iBAAA;AAPR;;AAWA;EACI,aAAA;EACA,2BAAA;AARJ;;AAWA;EACI,oBAAA;AARJ;;AAWA;EACI;IACI,aAAA;IACA,YAAA;EARN;;EAWE;IACI,WAAA;EARN;;EAWE;IACI,aAAA;IACA,YAAA;EARN;;EAWE;IACI,YAAA;EARN;EASM;IACI,eAAA;EAPV;EAUM;IACI,gBAAA;IACA,iBAAA;IACA,YAAA;IACA,eAAA;EARV;;EAYE;IACI,eAAA;IACA,YAAA;IACA,YAAA;EATN;AACF","sourcesContent":["@import \"./variables\";\n@mixin sizing() {\n    height:650px;\n    width:650px; \n}\n@mixin secondSizing(){\n    height: 625px;\n    width: 730px; \n}\n\n.serviceTopicDiv{\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 200px;\n\n}\n\n\n.serviceImg{\n    @include sizing();\n}\n\n.interiorImg{\n    @include secondSizing();\n}\n\n.flooringImg{\n    @include secondSizing();\n}\n\n.pressureImg{\n    height:685px;\n}  \n\n.serviceQuoteBtn{\n    background-color: $primaryOrange;\n    color: white;\n    border-style: none;\n    font-weight: 700;\n    height: 50px;\n    width: 150px;\n}\n\n.textsDiv{\n    width: 230px;\n    margin: 80px;\n    .servicePara{\n        font-weight:600;\n        line-height: 20px;\n    }\n}\n\n.rightFacing{\n    display: flex;\n    flex-direction: row-reverse;\n}\n\n.pressure2{\n    margin-bottom:100px;\n}\n\n@media (max-width: 425px){\n    .interiorImg{\n        height:425px;\n        width: 630px;\n    }\n\n    .rightFacing{\n        width: 232%;\n    }\n\n    .serviceImg{\n        height: 530px;\n        width: 550px;\n    }\n\n    .textsDiv{\n        width: 250px;\n        h3{\n            font-size: 35px;\n        }\n\n        .servicePara{\n            font-weight:600;\n            line-height: 33px;\n            width: 233px;\n            font-size: 24px;\n        }\n    }\n\n    .serviceQuoteBtn{\n        font-size: 22px;\n        height: 67px;\n        width: 200px;\n    }\n}\n\n","$primaryOrange: #F27400;\n$secondaryBlue: #111E4B;\n$baseWhite: #FDFDFD;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
